import { Component, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CatalogState } from '~app/modules/catalog/store';
import { Category } from '~app/modules/generic/models';
import { getCategory } from '~app/modules/generic/store';
import { MEDIA_ALISES } from '~shared/constants/media.constant';

@Component({
  selector: 'app-sub-category-grid-wrapper',
  templateUrl: './sub-category-grid-wrapper.component.html',
})
export class SubCategoryGridWrapperComponent implements OnInit {
  selectedCategory$: Observable<Category>;
  isMobile = false;
  isTablet = false;
  isDesktop = false;

  private unsubscribe$ = new Subject();

  constructor(private store$: Store<CatalogState>, private mediaObserver: MediaObserver) {}

  ngOnInit(): void {
    this.initializeSelectedCategory();
    this.initializeMediaObservable();
  }

  private initializeSelectedCategory(): void {
    this.selectedCategory$ = this.store$.pipe(select(getCategory));
  }

  private initializeMediaObservable(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
        this.isTablet = this.mediaObserver.isActive(MEDIA_ALISES.tablet);
        this.isDesktop = this.mediaObserver.isActive(MEDIA_ALISES.desktop);
      });
  }
}
